module.exports = __webpack_public_path__ + "assets/img/tanteLouise.d0012ddf.png";